/** Comprime una foto a ≤ 1280 px y JPEG ~0.8. Si el navegador no puede decodificarla (HEIC), lanza. */
export async function comprimirFoto(archivo: File, maxLado = 1280, calidad = 0.8): Promise<Blob> {
  const bitmap = await createImageBitmap(archivo, { imageOrientation: "from-image" } as ImageBitmapOptions);
  const escala = Math.min(1, maxLado / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * escala);
  const h = Math.round(bitmap.height * escala);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Sin canvas");
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close();
  const blob = await new Promise<Blob | null>((res) => canvas.toBlob(res, "image/jpeg", calidad));
  if (!blob) throw new Error("No se pudo comprimir la foto");
  return blob;
}
